<template>
  <router-link v-if="image" :to="{name: 'menu-page', params: {id: id}}"
               class="grid-item"
               :style="backgroundImage">
    <h5 class="title text-center">{{ name }}</h5>
  </router-link>
  <router-link v-else :to="{name: 'menu-page', params: {id: id}}"
               class="grid-item"
               :class="categoryClass"
  >
    <h5 class="title text-center">{{ name }}</h5>
  </router-link>
</template>

<script setup>

import {computed, onMounted} from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "Category"
  },
  id: {
    type: String,
    default: "1"
  }
})

// Image de fond selon la catégorie parente, sans tenir compte des accents, majuscules ni du pluriel
const categoryClass = computed(() => {
  const name = (props.name || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()

  if (name.startsWith('boisson')) return 'grid-drinks'
  if (name.startsWith('entree')) return 'grid-entries'
  if (name.startsWith('plat')) return 'grid-dishes'
  if (name.startsWith('dessert')) return 'grid-desserts'

  return 'grid-default'
})

onMounted(() => {
})


</script>

<style scoped>
  .grid-item{
    width: 42%;
    height: 110px;
    border-radius: 10px;
    background-blend-mode: overlay;
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    margin: 5px;
    justify-content: center;
    justify-items: center;
    align-items: center;
  }

  .grid-drinks {
    background-image: url('../assets/drinks.jpg'),linear-gradient(rgba(58, 69, 49, 0.21),rgba(10, 11, 10, 0.71));
  }

  .grid-entries {
    background-image: url('../assets/entries.jpg'),linear-gradient(rgba(58, 69, 49, 0.21),rgba(10, 11, 10, 0.71));
  }

  .grid-dishes {
    background-image: url('../assets/dishes.jpg'),linear-gradient(rgba(58, 69, 49, 0.21),rgba(10, 11, 10, 0.71));
  }

  .grid-desserts {
    background-image: url('../assets/desserts.jpg'),linear-gradient(rgba(58, 69, 49, 0.21),rgba(10, 11, 10, 0.71));
  }

  .grid-default {
    background-image: linear-gradient(rgba(58, 69, 49, 0.61),rgba(10, 11, 10, 0.91));
  }

  .title{
    align-self: center;
    margin-top: 55px;
    color: white;
  }
</style>